<template>
  <div>
    <button class="btn btn-sm btn-light btn-with-addon"
          @click="showModal"
        >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-eye" />
      </span>
      Holiday List
    </button>
    <a-drawer
      title="Holiday List"
      :width="this.settings['isMobileView'] ? 340 : 720"
      @close="handleCancel"
      :visible="visible"
      :wrapStyle="{height: 'calc(100% - 10px)', overflow: 'auto', paddingBottom: '10px'}"
      placement="right"
    >
      <a-spin :spinning="loading">
        <events-list :events="events" :showActions="false" :showEventType="false"/>
      </a-spin>
    </a-drawer>
  </div>
</template>

<style scoped>
.ant-drawer-close-x{
  margin-right: 0.7rem;
}
</style>

<script>
import { mapState } from 'vuex'
import EventsList from '@/components/calendar/Events/List/index'

export default {
  name: 'HolidayList',
  components: {
    EventsList,
  },
  data: function() {
    return {
      events: [],
      loading: false,
      visible: false,
      eventFilter: 'H',
    }
  },
  computed: mapState(['settings']),
  methods: {
    showModal() {
      this.visible = true
      this.getHolidays()
    },
    getHolidays: function () {
      this.loading = true
      this.$http.get('/api/calendar', {
        params: {
          filter: this.eventFilter,
        },
      }).then(({ data }) => {
        this.events = data.data
        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
      this.loading = false
    },
  },
}
</script>
